// src/utils/minioClient.js
import { S3Client } from "@aws-sdk/client-s3";

export const minioClient = new S3Client({
  region: "local",
  endpoint: process.env.REACT_APP_MINIO_ENDPOINT || "https://images.do.cloudwalker.tv/",
  credentials: {
    accessKeyId: process.env.REACT_APP_MINIO_ACCESS_KEY || "development_user",
    secretAccessKey: process.env.REACT_APP_MINIO_SECRET_KEY || "onlyTest",
  },
  forcePathStyle: true,
});
//
// 